import React from 'react';
import './footer.css';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const Footer = ({ onOpenAbout }) => {
  return (
    <footer className="footer-wrapper">
      {/* Wave top */}
<div className="footer-wave-top">
  <svg className="footer-wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="rgba(220, 24, 24, 0)" /> 
        <stop offset="100%" stopColor="var(--color-surface-elevated)" />
      </linearGradient>
    </defs>
    <path fill="url(#waveGradient)" d="M0,120 C480,0 960,0 1440,120 L1440,0 L0,0 Z"></path>
  </svg>
</div>


      {/* Ligne 1 : Nom + texte avec | */}
      <div className="footer-brand-section-inline">
        <span className="footer-brand-name">Gaëtan Crabeels</span>
        <span className="footer-separator">|</span>
        <span className="footer-brand-description-inline">
          Développeur freelance spécialisé dans la création de sites web modernes et performants.
        </span>
      </div>

      {/* Ligne 2 : 3 colonnes */}
      <div className="footer-columns">

        {/* Colonne 1 : Socials */}
        <div className="footer-column">
          <h3 className="footer-column-title">Réseaux</h3>
          <div className="footer-social-links-column">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-item">
              <FaLinkedin className="footer-social-icon" />
              <span>LinkedIn</span>
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="footer-social-item">
              <FaGithub className="footer-social-icon" />
              <span>GitHub</span>
            </a>
          </div>
        </div>

        {/* Colonne 2 : Parcours */}
        <div className="footer-column">
          <h3 className="footer-column-title">Parcours</h3>
          <div
            className="footer-nav-link"
            role="button"
            tabIndex={0}
            onClick={onOpenAbout}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onOpenAbout(); }}
          >
            À Propos
          </div>
        </div>

        {/* Colonne 3 : Contact */}
        <div className="footer-column">
          <h3 className="footer-column-title">Contact</h3>
          <div className="footer-contact-info">
            <div className="footer-contact-item">
              <span>+32 470 33 66 82</span>
            </div>
            <div className="footer-contact-item">
              <span>Crabeels.Gaetan@outlook.be</span>
            </div>
            
          </div>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p className="footer-bottom-text">
          © 2025 Gaëtan Crabeels. Tous droits réservés.
        </p>
      </div>

    </footer>
  );
};

export default Footer;
